define.alias("shared/components/shared/link", "media/components/shared/link");